import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from '../dialog.component';
import { ImageModuleComponent } from '../image-module/image-module.component';

@Component({
  selector: 'app-view-influencer-level',
  templateUrl: './view-influencer-level.component.html',
  styleUrls: ['./view-influencer-level.component.scss']
})
export class ViewInfluencerLevelComponent implements OnInit {
  loader: boolean = false;
  influencerLevel: any = [];
  viewType: any;

  influencerLevelThree:any=[];
  influencerLevelTwo:any=[];
  influencerLevelOne:any=[];

  constructor(public serve: DatabaseService,
    @Inject(MAT_DIALOG_DATA) public data,
    public toast: ToastrManager,
    public dialog1: DialogComponent, public dialogRef: MatDialogRef<ViewInfluencerLevelComponent>, public dialog: MatDialog,
    ) { 
    
  }

  ngOnInit() {
    this.getUserLeveldata();
  }

  getUserLeveldata() {
    this.loader = true;
    this.serve.post_rqst({'influencer_id': this.data.id }, "Influencer/allChildInfluencerList").subscribe((result) => {

      if (result['statusCode'] == 200) {
        this.loader = false;
        if(this.data.main_data == '1'){
          this.influencerLevelOne = result['result']['level_one'];
          console.log(this.influencerLevelOne);
         
        }

        if(this.data.main_data == '2'){
          this.influencerLevelTwo = result['result']['level_two'];
          console.log(this.influencerLevelTwo);
         
        }


        if(this.data.main_data == '3'){
          this.influencerLevelThree = result['result']['level_three'];
          console.log(this.influencerLevelThree);
        
        }

    
      } else {
        this.loader = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    })
  }
  

  goToImage(image) {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }

  closeDialog() {
    this.dialog.closeAll()
  }
  closeRefresh() {
    this.dialogRef.close(true);
  }

}
